// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const H5OutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 640 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V272h224v152c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v136H48V88zm392-24c-11.4 0-21.3 8.1-23.5 19.3l-32 160c-1.4 7.1.4 14.4 5 19.9s11.4 8.8 18.6 8.8H528c35.3 0 64 28.7 64 64s-28.7 64-64 64h-63.6c-13.8 0-26-8.8-30.4-21.9l-3.2-9.7c-4.2-12.6-17.8-19.4-30.4-15.2S381 371 385.2 383.6l3.2 9.7c11 32.7 41.5 54.7 76 54.7H528c61.9 0 112-50.1 112-112s-50.1-112-112-112h-90.7l22.4-112H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H440z"}}]},"name":"h5","theme":"outlined"};

const H5Outlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={H5OutlinedSvg} />;
  H5Outlined.displayName = 'H5Outlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(H5Outlined);
